import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Popover } from "@mui/material";
import { Card, CardBody } from "reactstrap";
import { CiFilter } from "react-icons/ci";

import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

import {
  PAYMENT_HISTORY_INITIAL_FILTERS,
  fetchStreamAndTermDropdowns,
  getVendorFilterCount,
} from "../helper";

const ListFilters = ({
  filters,
  setFilters,
  filterCount,
  setFilterCount,
  isLoading,
}) => {
  const masterDropdowns = useSelector(
    (state) => state.globalData.masterDropdowns,
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterForm, setFilterForm] = useState(filters);

  const [dropdownOptions, setDropdownOptions] = useState({
    term: [],
    bu: [],
    stream: [],
  });

  useEffect(() => {
    if (masterDropdowns?.term?.length && masterDropdowns?.stream?.length) {
      const bu = masterDropdowns.businessArea.map((item) => ({
        label: item.label,
        value: item.businessAreaId,
      }));

      const term = masterDropdowns.term.map((item) => ({
        label: item.label,
        value: item.id,
      }));

      const stream = masterDropdowns.stream;

      setDropdownOptions({
        term,
        bu,
        stream,
      });
    } else loadDropdowns();
  }, [masterDropdowns?.businessArea]);

  useEffect(() => {
    setFilterForm(filters);
  }, [filters]);

  const loadDropdowns = async () => {
    const bu = masterDropdowns.businessArea.map((item) => ({
      label: item.label,
      value: item.businessAreaId,
    }));

    const { streamOptions, termOptions } = await fetchStreamAndTermDropdowns();
    setDropdownOptions({
      bu,
      term: termOptions,
      stream: streamOptions,
    });
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const filterFormHandler = (value, key) => {
    setFilterForm((prev) => ({ ...prev, [key]: value ?? null }));
  };

  const resetFilterForm = () => {
    handleClose();
    setFilterForm(PAYMENT_HISTORY_INITIAL_FILTERS);
    setFilters(PAYMENT_HISTORY_INITIAL_FILTERS);
    setFilterCount(0);
  };

  const handleApplyFilter = () => {
    handleClose();

    const count = getVendorFilterCount(filterForm);
    setFilterCount(count);
    setFilters(filterForm);
  };

  const { bu, term, stream } = filterForm;

  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;

  return (
    <>
      <AButton
        onClick={handleClick}
        aria-describedby={id}
        updatedStyle={
          filterCount > 0
            ? { border: "1px solid #00B0F5", color: "#00B0F5" }
            : {}
        }
        disabled={isLoading}
      >
        <CiFilter />
        Filters {filterCount > 0 && `(${filterCount})`}
      </AButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Card
          className="mb-0 regular-body label-color"
          style={{ width: "330px", borderRadius: "12px" }}
        >
          <CardBody className="d-flex flex-column">
            <div className="text-bold text-lg mb-2">Filters</div>

            <div className="d-flex flex-column gap-md">
              <AAutoComplete
                label="BU"
                placeholder="Select"
                isMulti={true}
                isShowCount={true}
                items={dropdownOptions.bu}
                currentValue={bu}
                handleChange={(value) => filterFormHandler(value, "bu")}
              />

              <AAutoComplete
                label="Term"
                placeholder="Select"
                isMulti={true}
                isShowCount={true}
                items={dropdownOptions.term}
                currentValue={term}
                handleChange={(value) => filterFormHandler(value, "term")}
              />

              <AAutoComplete
                label="Stream"
                placeholder="Select"
                isMulti={true}
                isShowCount={true}
                items={dropdownOptions.stream}
                currentValue={stream}
                handleChange={(value) => filterFormHandler(value, "stream")}
              />

              <div className="mt-3 d-flex flex-row-reverse justify-content-between">
                <AButton
                  variant="primary_filled"
                  className="w-full"
                  onClick={handleApplyFilter}
                  disabled={!bu?.length && !term?.length && !stream?.length}
                >
                  Apply filter
                </AButton>

                {filterCount > 0 && (
                  <AButton
                    variant="outline"
                    className="button_remove_left_margin"
                    updatedStyle={{
                      border: "1px solid #CC5F5F",
                      color: "#CC5F5F",
                    }}
                    onClick={resetFilterForm}
                  >
                    Remove filter
                  </AButton>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </Popover>
    </>
  );
};

export default ListFilters;
